/** ----------------------------------------
    Cookie
 ---------------------------------------- */

/**
 * Do you like 'em crunchy or with a cup of
 * coffee? The class let's you create and
 * retrieve a cookie from a session. Nom
 * nom nom nom nom nom!
 */

export class Cookie {

    /**
     * @options         object name, value and expire time
     */

    constructor(options) {
        this.cookie = options;
    }

    /** ----------------------------------------
        Set Cookie
     ---------------------------------------- */

    /**
     * These methods will set a cookie within
     * the session, provide it with a name,
     * a value and an expire time in days.
     */

    setCookie() {
        let expires = '';

        if (this.cookie.days) {
            let now = new Date();
            now.setTime(now.getTime() + (this.cookie.days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + now.toUTCString();
        }

        document.cookie = this.cookie.name + '=' + (this.cookie.value || "") + expires + '; path=/';
    }

    /** ----------------------------------------
        Get Cookie
     ---------------------------------------- */

    /**
     * Just let this function know witch
     * cookie you want to retrieve, the rest
     * is magic! Nom nom nom nom nom!
     */

    getCookie() {
        let name = this.cookie.name + '=';
        let cookies = document.cookie.split(';');

        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i];

            while (cookie.charAt(0) == ' ') cookie = cookie.substring(1, cookie.length);

            if (cookie.indexOf(name) == 0)
                return cookie.substring(name.length, cookie.length);
        }

        return null;
    }

    /** ----------------------------------------
        Delete Cookie
     ---------------------------------------- */

    /**
     * Delete that cookie by setting the expire
     * date back to the '70s.
     */

    deleteCookie(name) {
        document.cookie = name ? name : this.cookie.name + '=; Max-Age=-99999999;';
    }
}